import { Fragment, useEffect, useState } from "react";
import {
  addIndex,
  filter,
  find,
  isEmpty,
  length,
  map,
  path,
  propEq,
  sortBy,
  toUpper
} from "ramda";
import { useIntl } from "react-intl";
import education from "../../../../i18n/definitions/education";
import Typography from "@mui/material/Typography";
import { getRajoitteetFromMaarays } from "@/utils/rajoitteetUtils";
import { getLocalizedProperty } from "@/services/lomakkeet/utils";
import LisatiedotHtmlLupa from "@/components/03-templates/HtmlLupanakyma/Lisatiedot";
import rajoitteet from "../../../../i18n/definitions/rajoitteet";
import { PropTypes } from "prop-types";
import { PaikallisenTietovarastonAvain } from "@/enums";
import localForage from "localforage";

export default function ValtakunnallisetKehittamistehtavatHtml({ maaraykset }) {
  const intl = useIntl();
  const localeUpper = toUpper(intl.locale);
  const [
    erityisetKoulutustehtavatKoodisto,
    setErityisetKoulutustehtavatKoodisto
  ] = useState([]);

  /** Fetch opetuksenJarjestamismuodot from storage */
  useEffect(() => {
    localForage
      .getItem(
        PaikallisenTietovarastonAvain.LUKIO_ERITYINEN_KOULUTUSTEHTAVA_UUSI
      )
      .then(erityisetKoulutustehtavat =>
        setErityisetKoulutustehtavatKoodisto(erityisetKoulutustehtavat)
      )
      .catch(err => {
        console.error(err);
      });
  }, []);

  const valtakunnallisetKehittamistehtavatMaaraykset = sortBy(
    m => parseFloat(`${m.koodiarvo}.${path(["meta", "ankkuri"], m)}`),
    filter(
      maarays =>
        maarays.kohde.tunniste === "valtakunnallinenkehittamistehtava" &&
        maarays.koodisto === "lukioerityinenkoulutustehtavauusi" &&
        maarays.meta.isValtakunnallinenKehitystehtava,
      maaraykset
    )
  );

  const lisatietomaarays = find(
    maarays =>
      maarays.kohde.tunniste === "valtakunnallinenkehittamistehtava" &&
      maarays.koodisto === "lisatietoja",
    maaraykset
  );

  return !isEmpty(valtakunnallisetKehittamistehtavatMaaraykset) &&
    !isEmpty(erityisetKoulutustehtavatKoodisto) ? (
    <div className="mt-4">
      <Typography component="h3" variant="h3">
        {intl.formatMessage(education.valtakunnallinenKehittamistehtava)}
      </Typography>

      <p className="mb-4">
        {intl.formatMessage(education.valtakunnallinenKehittamistehtavaInfo)}
      </p>

      <ul className="ml-8 list-disc mb-4">
        {addIndex(map)((maarays, index) => {
          let naytettavaArvo = path(["meta", "kuvaus"], maarays);

          if (!naytettavaArvo) {
            const koodistosta = find(
              propEq("koodiarvo", maarays.koodiarvo),
              erityisetKoulutustehtavatKoodisto
            );

            naytettavaArvo = getLocalizedProperty(
              koodistosta.metadata,
              localeUpper,
              "kuvaus"
            );
          }

          return (
            <Fragment key={`${maarays.koodiarvo}-${index}`}>
              <li
                className={`leading-bulletList ${
                  length(maarays.aliMaaraykset) ? "mb-2" : ""
                }`}>
                {naytettavaArvo}
                {length(maarays.aliMaaraykset)
                  ? getRajoitteetFromMaarays(
                      maarays.aliMaaraykset,
                      localeUpper,
                      intl.formatMessage(rajoitteet.ajalla),
                      "kuvaus"
                    )
                  : ""}
              </li>
            </Fragment>
          );
        }, valtakunnallisetKehittamistehtavatMaaraykset)}
      </ul>
      <LisatiedotHtmlLupa lisatietomaarays={lisatietomaarays} />
    </div>
  ) : null;
}

ValtakunnallisetKehittamistehtavatHtml.propTypes = {
  maaraykset: PropTypes.array
};
